var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.userData,"items-per-page":5}})}
var staticRenderFns = []

export { render, staticRenderFns }